var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context",class:{'is-inline': _vm.isInline}},[(!_vm.isInline || _vm.window.is.mobile)?_c('div',{staticClass:"context-info"},[_c('div',{staticClass:"context-name"},[_vm._v("My Account")]),_c('div',{staticClass:"context-username"},[_vm._v("@"+_vm._s(_vm.username))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }